import flatSale from './flat-sale';
import roomSale from './room-sale';
import newBuildingFlatSale from './new-building-flat-sale';
import flatShareSale from './flat-share-sale';
import houseSale from './house-sale';
import houseShareSale from './house-share-sale';
import landSale from './land-sale';
import flatRent from './flat-rent';
import roomRent from './room-rent';
import bedRent from './bed-rent';
import houseRent from './house-rent';
import houseShareRent from './house-share-rent';
import dailyFlatRent from './daily-flat-rent';
import dailyRoomRent from './daily-room-rent';
import dailyHouseRent from './daily-house-rent';
import dailyBedRent from './daily-bed-rent';
import officeRent from './office-rent';
import warehouseRent from './warehouse-rent';
import shoppingAreaRent from './shopping-area-rent';
import industryRent from './industry-rent';
import buildingRent from './building-rent';
import commercialLandRent from './commercial-land-rent';
import freeAppointmentObjectRent from './free-appointment-object-rent';
import businessRent from './business-rent';
import garageRent from './garage-rent';
import officeSale from './office-sale';
import warehouseSale from './warehouse-sale';
import shoppingAreaSale from './shopping-area-sale';
import industrySale from './industry-sale';
import buildingSale from './building-sale';
import commercialLandSale from './commercial-land-sale';
import freeAppointmentObjectSale from './free-appointment-object-sale';
import businessSale from './business-sale';
import garageSale from './garage-sale';

export default {
    flatSale,
    roomSale,
    newBuildingFlatSale,
    flatShareSale,
    houseSale,
    cottageSale: houseSale,
    townhouseSale: houseSale,
    houseShareSale,
    landSale,
    flatRent,
    roomRent,
    bedRent,
    houseRent,
    cottageRent: houseRent,
    townhouseRent: houseRent,
    houseShareRent,
    dailyFlatRent,
    dailyRoomRent,
    dailyHouseRent,
    dailyBedRent,
    officeRent,
    warehouseRent,
    shoppingAreaRent,
    industryRent,
    buildingRent,
    commercialLandRent,
    freeAppointmentObjectRent,
    businessRent,
    garageRent,
    officeSale,
    warehouseSale,
    shoppingAreaSale,
    industrySale,
    buildingSale,
    commercialLandSale,
    freeAppointmentObjectSale,
    businessSale,
    garageSale
};
